export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/teradata.bc9a1e6.svg";